module.exports = __webpack_public_path__ + "1b71264ea551434db7d533fc0df6654f.pdf";